import { Injectable } from '@angular/core';
import { UnsplashApiManagerService } from '../../../../../services/assets-collection/unsplash/unsplash-api-manager.service';
import { Photos } from 'unsplash-js/dist/methods/search/types/response';
import {
    IGetAssetFromCollection,
    IAssetFromCollection,
    IAssetCollectionService,
    ISourceToImage,
} from '../photos-list/photo-list-model';

@Injectable()
export class UnsplashManagerService implements IAssetCollectionService {
    readonly source: Readonly<ISourceToImage>;
    readonly type: 'image' | 'video';
    constructor(private unsplashApiManager: UnsplashApiManagerService) {
        this.source = {
            linkTo: 'https://unsplash.com/?utm_source=shuffll&utm_medium=referral',
            name: 'Unsplash',
            imageSrc: '/assets/images/icons/unsplash_logo.svg',
        };
        this.type = 'image';
    }

    async getAssetsAsync(prompt: string, itemsPerPage: number, page: number): Promise<IGetAssetFromCollection> {
        if (!prompt) {
            return;
        }
        const axiosResponse = await this.unsplashApiManager.searchPhotosAsync({
            query: prompt,
            perPage: itemsPerPage ?? 5,
            page: page ?? 1,
        });
        const getPhotoRes: IGetAssetFromCollection = {
            payload: null,
            errorMessage: null,
        };
        if (axiosResponse.errors || !axiosResponse.response) {
            getPhotoRes.errorMessage = 'An error occurred';
            return getPhotoRes;
        }
        const data = axiosResponse.response;
        const localPhotos = this.convertPhotosFromUnsplash(data);
        getPhotoRes.payload = {
            photos: localPhotos,
            totalPages: data.total_pages,
            totalItems: data.total,
        };
        return getPhotoRes;
    }

    convertPhotosFromUnsplash(unsplashResult: Photos) {
        const { results: unsplashPhotos } = unsplashResult;
        if (!unsplashPhotos || unsplashPhotos.length === 0) {
            return [];
        }
        const localPhotos: IAssetFromCollection[] = [];
        for (const unsPhoto of unsplashPhotos) {
            if (!unsPhoto) {
                continue;
            }
            const urls = unsPhoto.urls;
            if (!urls) {
                continue;
            }
            const localPhoto: IAssetFromCollection = {
                id: unsPhoto.id,
                urls: {
                    raw: urls.raw,
                    full: urls.full,
                    regular: urls.regular,
                    small: urls.small,
                    thumb: urls.thumb,
                },
                description: unsPhoto.description,
                photographer: {
                    name: unsPhoto.user.name,
                    linkToProfile: `${unsPhoto.user.links.html}?utm_source=shuffll&utm_medium=referral`,
                },
                type: 'image',
                duration: null,
            };
            localPhotos.push(localPhoto);
        }
        return localPhotos;
    }
}
